<template>
  <p v-if="data && (data.updated_label || data.sources?.length)" class="text-xs text-[#64748B] mt-3">
    <span v-if="data.updated_label">Last updated: <time :datetime="data.updated_at">{{ data.updated_label }}</time></span>
    <span v-if="data.sources?.length && !hideSources"> · Sources: {{ data.sources.join(' · ') }}</span>
    <span> · <router-link to="/methodology" class="underline hover:text-[#2563EB]">How we collect data</router-link></span>
  </p>
</template>

<script setup>
// Mirrors resources/views/ssr/partials/freshness.blade.php.
import { computed } from 'vue';
import { page } from '../page';

const props = defineProps({ value: { type: Object, default: null }, hideSources: { type: Boolean, default: false } });
const data = computed(() => props.value || page.freshness);
</script>
